import { Package } from "@/types/packages/data-only/DataOnlyCountryPackages";
import { useState } from "react";

export function usePackagesFilter(activePackages: Package[]) {
  const [validityFilter, setValidityFilter] = useState<number | null>(null);
  const [dataFilter, setDataFilter] = useState<number | null>(null);
  const [openFilters, setOpenFilters] = useState(false);

  let filteredPackages = activePackages;

  if (validityFilter != null) {
    filteredPackages = filteredPackages.filter(
      (pkg) => pkg.package_validity === validityFilter,
    );
  }

  if (dataFilter != null) {
    filteredPackages = filteredPackages.filter(
      (pkg) => pkg.data_quantity === dataFilter,
    );
  }

  const haveFilteredPackages = filteredPackages.length > 0;
  const isAnyFilterApplied = dataFilter != null || validityFilter != null;
  const isBothFilterApplied = dataFilter != null && validityFilter != null;

  function handleFilterByValidity(filter: string) {
    setValidityFilter(filter === "" ? null : Number(filter));
  }

  function handleFilterByData(filter: string) {
    const nextData = filter === "" ? null : Number(filter);
    setDataFilter(nextData);

    if (nextData != null && validityFilter != null) {
      const isCompatible = activePackages.some(
        (pkg) =>
          pkg.data_quantity === nextData &&
          pkg.package_validity === validityFilter,
      );
      if (!isCompatible) setValidityFilter(null);
    }
  }

  function handleClearFilter() {
    setValidityFilter(null);
    setDataFilter(null);
  }

  return {
    validityFilter,
    setValidityFilter,
    dataFilter,
    setDataFilter,
    filteredPackages,
    haveFilteredPackages,
    isAnyFilterApplied,
    isBothFilterApplied,
    handleFilterByValidity,
    handleFilterByData,
    handleClearFilter,
    openFilters,
    setOpenFilters,
  };
}
